
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import Cta from '@/partials/Cta'
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "Showcase",
  "date": "2021-05-05"
};
const slug = 'showcase';
const tableOfContents = [{
  "title": "Quick Links",
  "slug": "quick-links",
  "children": []
}, {
  "title": "Spanish Marketplace App - Ventco (Colombia 🇨🇴)",
  "slug": "spanish-marketplace-app-ventco-colombia",
  "children": []
}, {
  "title": "Fashion Marketplace - Velvet (Malta 🇲🇹)",
  "slug": "fashion-marketplace-velvet-malta",
  "children": []
}, {
  "title": "Plant Marketplace (Australia)",
  "slug": "plant-marketplace-australia",
  "children": []
}, {
  "title": "Waneko - Marketplace in Senegal 🇸🇳, Africa",
  "slug": "waneko-marketplace-in-senegal-africa",
  "children": []
}, {
  "title": "Nammakada - India Local Marketplace",
  "slug": "nammakada-india-local-marketplace",
  "children": []
}, {
  "title": "Local Hong Kong Based Marketplace",
  "slug": "local-hong-kong-based-marketplace",
  "children": []
}, {
  "title": "App Built on Tradly Headless Solution",
  "slug": "app-built-on-tradly-headless-solution",
  "children": []
}, {
  "title": "Global Impact",
  "slug": "global-impact",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <h1>{`Showcase Of Our App That Runs on Tradly Infrastructure`}</h1>
    <_Heading level={2} id={"quick-links"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Quick Links</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://theprelovedclub.com"
        }}>{`Prelovedclub from UAE`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://velvet.tradly.co/"
        }}>{`Velvet from Malta`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://web.wyldeplants.com.au/"
        }}>{`Wyldeplants from Australia`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://nammakada.app/"
        }}>{`Nammakada from India`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://marketplace.tradly.app/"
        }}>{`Tradly Marketplace`}</a></li>
    </ul>
    <_Heading level={2} id={"spanish-marketplace-app-ventco-colombia"} nextElement={{
      "type": "paragraph"
    }}>Spanish Marketplace App - Ventco (Colombia 🇨🇴)</_Heading>
    <p>{`Ventco Marketplace to buy and sell products. Subscribed to Tradly full stack solution.`}</p>
    <p><strong parentName="p">{`Country:`}</strong>{` Colombia`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Language:`}</strong>{` Spanish`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Revenue Model:`}</strong>{` Listing Markup fixed fee + Listing commission %`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Uniqueness:`}</strong>{` Tradly doesn’t support payment platforms in Latin America. With client trust and support, we embarked on testing 2 different payment gateways and finally decided to go ahead with PayU. As PayU doesn’t support split payment, we developed a special mechanism (markup on Listing price + variable cost as well) as a new revenue model.`}</p>
    <blockquote>
      <p parentName="blockquote">{`“Tradly est une platforme proposant énormément de services et cela m’a permis de gagner énormément de temps sur la construction d’un projet de marketplace. De plus Tradly comprend un accès membre sur Slack, qui nous permet de communiquer très facilement, l’équipe est au top, toujours disponible pour nous aider. Je remercie leur travail sérieux et leur investissement dans les projets ! Je recommande vraiment cette plate-forme que ce soit pour un entrepreneur ou un développeur, se lancer n’a jamais été aussi facile ! Merci Tradly” - Mathiue`}</p>
    </blockquote>
    <div className="flex flex-wrap gap-4">
  <img className="w-60 h-100 object-cover rounded-lg shadow-lg" src="/img/IMG_1434.png" alt="Spanish Marketplace App" />
    </div>
    <div className="mb-[90px]" />
    <_Heading level={2} id={"fashion-marketplace-velvet-malta"} nextElement={{
      "type": "paragraph"
    }}>Fashion Marketplace - Velvet (Malta 🇲🇹)</_Heading>
    <p>{`Women Marketplace to buy and sell second hand fashion items. Subscribed to Tradly full stack solution.`}</p>
    <p><strong parentName="p">{`Country:`}</strong>{` Malta`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Revenue Model:`}</strong>{` Commission %`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Uniqueness:`}</strong>{` Using their storage hub to manage the delivery and pickup operation.`}</p>
    <blockquote>
      <p parentName="blockquote">{`“I am a developer, but I prefer to use Tradly because it allows me to get on the market quickly, without waiting 6 months of development” - Pierre`}</p>
    </blockquote>
    <div className="flex flex-wrap gap-4">
  <img className="w-60 h-100 object-cover rounded-lg shadow-lg" src="/img/IMG_1438-768x1365.png" alt="Fashion marketplace app from Malta" />
  <img className="w-60 h-100 object-cover rounded-lg shadow-lg" src="/img/IMG_1439-768x1365.png" alt="Fashion marketplace app from Malta" />
    </div>
    <div className="mb-[90px]" />
    <_Heading level={2} id={"plant-marketplace-australia"} nextElement={{
      "type": "jsx"
    }}>Plant Marketplace (Australia)</_Heading>
    <div className="flex flex-wrap gap-4">
  <img className="w-60 h-100 object-cover rounded-lg shadow-lg" src="/img/IMG_1444-768x1365.png" alt="Plant Marketplace from Australia" />
  <img className="w-60 h-100 object-cover rounded-lg shadow-lg" src="/img/IMG_1445-768x1365.png" alt="Plant Marketplace from Australia" />
  <img className="w-60 h-100 object-cover rounded-lg shadow-lg" src="/img/IMG_1443-768x1365.png" alt="Automated Payout escrow system" />
    </div>
    <div className="mb-[90px]" />
    <_Heading level={2} id={"waneko-marketplace-in-senegal-africa"} nextElement={{
      "type": "paragraph"
    }}>Waneko - Marketplace in Senegal 🇸🇳, Africa</_Heading>
    <p><strong parentName="p">{`Language:`}</strong>{` French`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Revenue Model:`}</strong>{` Subscription Fee`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Uniqueness:`}</strong>{` As Senegal doesn’t have advanced payment system to enable marketplace split payments. We helped them to have subscription based business. Integrated a new payment gateway “PayDunya” And activated a subscription mechanism where their seller will need to have active subscription before selling items in the marketplace.`}</p>
    <div className="flex flex-wrap gap-4">
  <img className="w-60 h-100 object-cover rounded-lg shadow-lg" src="/img/IMG_1446-768x1365.png" alt="French Marketplace in Africa" />
  <img className="w-60 h-100 object-cover rounded-lg shadow-lg" src="/img/IMG_1447-768x1365.png" alt="French Marketplace in Africa" />
  <img className="w-60 h-100 object-cover rounded-lg shadow-lg" src="/img/IMG_1451-768x1365.png" alt="French Marketplace App" />
  <img className="w-60 h-100 object-cover rounded-lg shadow-lg" src="/img/IMG_1452-768x1365.png" alt="French Marketplace in Africa" />
    </div>
    <div className="mb-[90px]" />
    <_Heading level={2} id={"nammakada-india-local-marketplace"} nextElement={{
      "type": "paragraph"
    }}>Nammakada - India Local Marketplace</_Heading>
    <p><a parentName="p" {...{
        "href": "https://play.google.com/store/apps/details?id=nammakada.app&hl=en&gl=US"
      }}>{`Google Play`}</a>{` | `}<a parentName="p" {...{
        "href": "https://nammakada.app/"
      }}>{`Website`}</a></p>
    <div className="flex flex-wrap gap-4">
  <img className="w-160 h-100 object-cover rounded-lg shadow-lg" src="/img/nammakada-app.png" alt="Nammakada on Mobile App" />
  <img className="w-160 h-100 object-cover rounded-lg shadow-lg" src="/img/nammakada-website.png" alt="Nammakada on Website" />
    </div>
    <div className="mb-[90px]" />
    <_Heading level={2} id={"local-hong-kong-based-marketplace"} nextElement={{
      "type": "jsx"
    }}>Local Hong Kong Based Marketplace</_Heading>
    <div className="flex flex-wrap gap-4">
  <img className="w-60 h-100 object-cover rounded-lg shadow-lg" src="/img/IMG_1453-768x1365.png" alt="Hong Kong based marketplace" />
  <img className="w-60 h-100 object-cover rounded-lg shadow-lg" src="/img/IMG_1455-768x1365.png" alt="Hong Kong based marketplace" />
    </div>
    <div className="mb-[90px]" />
    <_Heading level={2} id={"app-built-on-tradly-headless-solution"} nextElement={{
      "type": "jsx"
    }}>App Built on Tradly Headless Solution</_Heading>
    <div className="flex flex-wrap gap-4">
  <img className="w-60 h-100 object-cover rounded-lg shadow-lg" src="/img/Image-from-iOS-4-768x1505.png" alt="US Marketplace App" />
  <img className="w-60 h-100 object-cover rounded-lg shadow-lg" src="/img/Image-from-iOS-5-768x1662.png" alt="US Marketplace App" />
  <img className="w-60 h-100 object-cover rounded-lg shadow-lg" src="/img/Image-from-iOS-7-768x1505.png" alt="US Marketplace App" />
  <img className="w-60 h-100 object-cover rounded-lg shadow-lg" src="/img/Image-from-iOS-8-768x1505.png" alt="US Marketplace App" />
  <img className="w-60 h-100 object-cover rounded-lg shadow-lg" src="/img/Image-from-iOS-9-768x1505.png" alt="US Marketplace App" />
  <img className="w-60 h-100 object-cover rounded-lg shadow-lg" src="/img/Image-from-iOS-10-768x1505.png" alt="US Marketplace App" />
    </div>
    <div className="mb-[90px]" />
    <_Heading level={2} id={"global-impact"} nextElement={{
      "type": "paragraph"
    }}>Global Impact</_Heading>
    <p><strong parentName="p">{`Supporting developing economies around the world`}</strong>{`. Notable countries we are making impact:`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Senegal, Africa (French)`}</li>
      <li parentName="ul">{`Colombia, LATAM (Spanish)`}</li>
      <li parentName="ul">{`Malta, Europe`}</li>
    </ul>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Arabic and Chinese versions of the app have been delivered.`}</li>
    </ul>
    <Cta mdxType="Cta" />



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
